<template>
  <v-dialog
    v-model="dialogOpen"
    persistent
    fullscreen
    scrollable>
    <v-card class="form-tabs">
      <v-toolbar color="white" flat>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer/>
        <v-btn icon @click="dialogOpen = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form ref="formItem" 
        @submit.prevent="submit"
        v-model="validData">
          <v-container class="container-form-stock">

            <span style="
            margin-left: 70px;
            padding-bottom: 50px;
            font-weight: bold;
            font-size: 19px;" >
            {{isEdit ? 'Edición de almacén':'Registro de almacén'}}</span>

            <div class="form-row-stock">

              <v-autocomplete
                style="max-width: 40%; margin-top: 20px; margin-left: 70px;"
                v-model="postSelected"
                :items="sortedTerminals"
                item-text="text"
                item-value="value"
                label="Terminal de venta u operación"
                :disabled = isEdit
                :rules="rules.required"
                hide-details="auto"/>

              <v-radio-group
               v-model="type" row :disabled = isEdit
               :rules="rules.required">
                <v-radio label="Entrada" value="in"
                style="margin-right: 80px;"/>
                <v-radio label="Salida" value="out"/>
              </v-radio-group>

            </div>

            <div v-if="!isEdit" class="form-row-stock">
               <div>
                <span></span>
              </div>

               <v-btn
                color="purple"
                text
                rounded
                @click="addNewStock"> 
                <div  class="form-row-stock">
                  <span style="color: #7954C2; font-weight: bold;">Agregar producto</span> 
                </div>
              </v-btn>
              
            </div>
           
            <div v-for="(item, index) in stock" :key="index"
              style="padding-top: 50px; overflow-x: auto;">
              <div class="form-row-stock">

                <v-btn
                  v-if="!isEdit"
                  color="red"
                  text
                  rounded
                  @click="deleteItem(item)"> 
                  <v-icon>close</v-icon>
                </v-btn>

                <v-autocomplete
                  :style="{
                    maxWidth: '30%',
                    marginLeft: isEdit ? '70px' : '0'
                  }"
                  v-model="item.product_id"
                  :items="sortedProducts"
                  :item-text="formatProduct"
                  item-value="_id"
                  label="Producto"
                  dense
                  :disabled="isEdit"
                  :rules="rules.required"
                  hide-details="auto"
                  @change="productId => onProductChange(productId, item)"/>
              
                <v-text-field
                  style="max-width: 15%;"
                  v-model.number="item.quantity"
                  label="Cantidad"
                  type="number"
                  :rules="rules.required"
                  required
                  dense
                  :disabled = isEdit
                  @input="onChangeTotal(item)"/>

                <v-text-field
                  style="max-width: 15%;"
                  v-model.number="item.cost"
                  label="Costo Unitario"
                  type="number"
                  required
                  dense
                  :disabled = isOut
                  @input="onChangeTotal(item)"/>

                <v-text-field
                  style="max-width: 15%;"
                  v-model="item.total"
                  label="Total"
                  dense disabled/>

                <v-text-field
                  style="max-width: 15%;"
                  v-model="item.prod_price"
                  label="Precio de Venta"
                  dense/>
              </div>

              <v-textarea
              style="margin-left: 70px;"
                v-model="item.note"
                label="Nota"
                dense
                auto-grow
                rows="3"/>

            </div>
               

          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="btns-form-stock">

        
        <v-btn
          style="width: 200px;"
          color="primary"
          text
          @click="dialogOpen = false">
          Cancelar
        </v-btn>
        <v-btn
        style="width: 200px;"
          color="black"
          rounded
          :dark="validData"
          :loading="isSavingData"
          :disabled="!validData"
          @click="addData()">
          Guardar
        </v-btn>

      </v-card-actions>
    </v-card>
    <snack-bar-message ref="snackMessages"/>
  </v-dialog>
</template>


<script>
import axios from 'axios';
import SnackBarMessage from './SnackBarMessage.vue';
export default {
    name: 'CyphraWebAddEditStockModal',
    props: ["terminals"],
    components: {
        SnackBarMessage
    },
    data() {
        return {
            dialogOpen: false,
            isEdit: false,
            validData: false,
            isSavingData: false,
            postSelected:"",
            type:"",
            total:0,
            products:[],
            stock:[],
            businessId:"",
            itemEmpty: {
              alias: "",
              edited_by: "",
              product_id: "",
              product_sku: "",
              product_name:"",
              terminal_id:"",
              business_id:"",
              type:"",
              cost:0,
              quantity:0,
              note:"",
              total:0, 
              prod_price:0,
            },
            rules: {
              required: [ v => !!v || 'Campo requerido.']
            }
        };
    },
    watch: {
      postSelected(newValue, oldValue) {
        this.getProducts(newValue)
      }, 
    },
    
    computed: {
      isOut() {
        return this.type === "out";
      },
      sortedTerminals() {
        return this.terminals.slice().sort((a, b) => {
        return a.text.localeCompare(b.text);
        });
      },
      sortedProducts() {
        return this.products.slice().sort((a, b) => {
          return a.prod_sku.localeCompare(b.prod_sku);
        });
      }
    },

    methods: { 
        onProductChange(selectedId, item) {
          const selectedProduct = this.products.find(p => p._id === selectedId);
          if (selectedProduct) {
            console.log(selectedProduct)
            item.product_name = selectedProduct.prod_name;
            item.product_sku = selectedProduct.prod_sku;
            item.prod_price = selectedProduct.prod_price;
          }
        },
        onChangeTotal(item) {
          const cost = parseFloat(item.cost) || 0;
          const quantity = parseFloat(item.quantity) || 0;
          item.total = cost * quantity;
        },
        reset () {
            this.$refs.formItem.reset()
            this.stock = []
        },
        resetValidation () {
            this.$refs.formItem.resetValidation()
        },
        open(item, business){
          this.dialogOpen = true;
          this.businessId = business
          if(item) {
            this.isEdit = true
            this.stock = []
            item.total = item.cost * item.quantity;
            this.stock.push(JSON.parse(JSON.stringify(item)))
            this.postSelected = item.terminal_id._id
            this.type = item.type
            this.getProductPrice()
          } else {
            this.isEdit = false
            this.stock = []
            this.stock.push(JSON.parse(JSON.stringify(this.itemEmpty)))
            this.$refs.formItem.resetValidation()
            this.$refs.formItem.reset()
          }
        },
        addNewStock(){
          this.stock.push(JSON.parse(JSON.stringify(this.itemEmpty)))
        },
        deleteItem(item) {
          const index = this.stock.indexOf(item);
          if (index !== -1) {
            this.stock.splice(index, 1);
          }
        },
        async addData() {
          const timestamp = new Date().toISOString();
          const userData = this.$store.state.user
          this.stock.forEach((item, index) => {
            item.alias = timestamp +"="+index
            item.edited_by = userData._id
            item.business_id = this.businessId
            item.type = this.type
            item.terminal_id = this.postSelected
            console.log(item)
            this.saveStock(item)
          });
           this.$bus.$emit('refreshList', true);
          this.isSavingData = false;
          this.dialogOpen = false;
        },

        async saveStock(stockData){
            const saveUrl = this.isEdit ? 'stock/edit' : 'stock/add';
            axios.post(saveUrl,stockData).then(async response => {
            console.log("save OK")
          }).catch(err => {console.log(err)});
        },

        async getProducts(idPos){
          const me = this
          const urlApi = 'products/listByPos?terminal_id=' + idPos + '&page=1' + '&limit=10000'
          axios.get(urlApi).then(function (response){
            me.products = response.data.products
            me.getProductPrice()
          } )  
        },

        getProductPrice(){
          if( this.isEdit && this.stock.length > 0){
            for(let item of this.products){
              if(item._id === this.stock[0].product_id){
                this.stock[0].prod_price = parseInt(item.prod_price)
              }
            }
          }
        },

        formatProduct(product) {
          return `${product.prod_sku} - ${product.prod_name}`;
        },
       
    },
};
</script>

<style scoped>
@import './../../assets/styles/custom-input.css';

.container-form-stock{
  width: 80%;
  padding-right: 70px;
  height: 80vh;  
}

.form-row-stock{
  display: flex;
  justify-content: space-between;
}

.btns-form-stock{
  width: 84%;
  display:flex;
  justify-content: end;
  margin-bottom: 20px;
}



</style>